import { CandidateApiService } from 'candidate/CandidateApiService';
import { CandidateActiveCv } from 'candidate/types';
import { JobApiService } from 'jobs/JobApiService';
import { CandidateCV } from 'jobs/types';
import React, { useEffect } from 'react';

export const useLoadCvLists = () => {
    const [loading, setLoading] = React.useState(false);
    const [cvList, setCvList] = React.useState<CandidateCV[]>([]);
    const [activeCvList, setactiveCvList] = React.useState<CandidateActiveCv[]>([]);

    useEffect(() => {
        setLoading(true);
        Promise.allSettled([
            JobApiService.jobApplyGetFileList(),
            CandidateApiService.candidatesGetActiveCvList(),
        ])
            .then(([resApplyCv, resCandidateActiveCv]) => {
                if (resApplyCv.status === 'fulfilled' && resApplyCv.value.status === 200) {
                    setCvList(resApplyCv.value.response.filesList);
                }
                if (
                    resCandidateActiveCv.status === 'fulfilled' &&
                    resCandidateActiveCv.value.status === 200
                ) {
                    setactiveCvList(resCandidateActiveCv.value.response);
                }
            })
            .catch((e) => {})
            .finally(() => setLoading(false));
    }, []);

    return { loading, cvList, activeCvList };
};
